/**
 * Builds the createSession payload field for stableDepositAddressKey.
 * When omitting (regenerate), returns {} so the key is absent from the request body.
 */
export function stableDepositAddressKeyPayload(
  configuredKey: string | undefined,
  omitStableDepositAddressKey = false,
): { stableDepositAddressKey?: string } {
  if (omitStableDepositAddressKey || !configuredKey) {
    return {};
  }

  return { stableDepositAddressKey: configuredKey };
}
